// ** React Imports
import React from "react";

// ** Profile sections (style-v3)
import ShowUserInfo from "./LeftProfileView/ProfilePreview/ShowUserInfo";
import SecurityTab from "./RightProfileView/Tab/SecurityTab/SecurityTab";
import BackToCourses from "src/@core/components/salespark/BackToCourses";

// ** Styles
import "src/styles/style-v3.css";

/******************************************************************
 * ##: MainUserLayout
 * Profile page (style-v3). Left column is the identity card, right
 * column the account actions (currently: change password). The old
 * empty "Visão Geral" tab and the disabled "Editar" button were
 * dropped since neither carried real functionality.
 * @returns {JSX.Element} - the v3 profile layout
 * History:
 * 05-07-2026: Rebuilt with style-v3 (identity card + security panel)
 ******************************************************************/
function MainUserLayout() {
  return (
    <div className="spv3">
      <div className="spv3-pagehead">
        <div className="spv3-pagehead__text">
          <span className="spv3-eyebrow">A minha conta</span>
          <h1 className="spv3-pagehead__title">O meu perfil</h1>
        </div>
        <BackToCourses />
      </div>

      <div className="spv3-profile">
        <aside>
          <ShowUserInfo />
        </aside>
        <section>
          <SecurityTab />
        </section>
      </div>
    </div>
  );
}

export default MainUserLayout;
